/* Copyright (c) 2023 Xperi. All Rights Reserved. */

/* eslint-disable no-shadow */
/* eslint-disable no-unused-vars */
export enum SpinnerDelays {
    LIVE_TV = 4 * 1000,
    GUIDE = 5 * 1000,
}
